import React, { useEffect, useState } from 'react'
import { useOutletContext } from 'react-router-dom';
import Download_icon from "../../images/download_icon.svg";
import Loading from '../common/Loading/Loading';
import "./repxfiles.css"

/**
 * Files tab in the Report page. It displays files for the RepX files.
 * These files are located in the repx-output bucket in a directory with the same name as the 
 * RepX CSV and on the directory /extras -> repx-output/repxfile/extras
 */

function RepXFiles() {
    const [files, setFiles] = useState([]);
    const [spinner, setSpinner] = useState(true);
    const getS3 = useOutletContext().getS3;
    const [S3, setS3] = useState(null);
  
    useEffect(() => {
      getS3().then(setS3);
    }, [])
  
    const bucketName = process.env.REACT_APP_S3_REPX_OUTPUT;
    const selectedSnapshot = localStorage.getItem('selectedSnapshot');
    useEffect(() => {
        if(!S3) return;
        setSpinner(true);
        if (selectedSnapshot) {
          const directoryPath = `${selectedSnapshot}/extras/`;
          const params = {
            Bucket: bucketName,
            Prefix: directoryPath
          };
    
          S3.listObjectsV2(params, (err, data) => {
            if (err) {
              console.error(err);
            } else {
              const fileNames = data.Contents.map(file => file.Key.replace(directoryPath, ''));
              setFiles(fileNames);
              setSpinner(false);
            }
          });
        }
      }, [S3]);
  return (
    <div>
        {spinner ? (
          <div
          style={{
            display: "flex",
            justifyContent: "center",
            fontSize: "2rem",
            position: "absolute",
            right: "50%",
            top: "50%",
          }}
        >
          <Loading />
        </div>
        ): files.length > 0 ? (
            <table id='repx-files-table'>
            <thead>
                <tr>
                <th></th>
                <th>File name</th>
                <th>Notes</th>
                <th></th>
                </tr>
            </thead>
            <tbody className='repx-files-body'>
            {files.map((file, index) => (
            <tr key={index}>
              <td>FILE {index + 1}</td>
              <td>{file}</td>
              <td>Notes for {file}</td>
              <td><a href={`https://${bucketName}.s3.amazonaws.com/${selectedSnapshot}/extras/${file}`} download>
              <button className='repx-download-btn'>
                <img src={Download_icon} alt='download file'/>
              </button>
              </a></td>
            </tr>
          ))}
            </tbody>
        </table>
        ): (
            <div className='no-snapshots'>You have no files yet. Check back when your RepX report has been generated.</div>
        )}
        
    </div>
  )
}

export default RepXFiles